import React from "react";

const GameCardLayout = ({ className, title, text, children }) => {
  return (
    <div
      style={{
        boxShadow: "0 0 20px rgba(255,255,255,0.20)",
      }}
      className={`${className} sm:px-7 xs:px-5 px-4 sm:py-10 xs:py-8 py-6 bg-[#000] border-2 border-[#434343] rounded-[30px] flex flex-col items-center`}
    >
      <div className="flex flex-col gap-y-1 items-center w-full">
        <h1 className="xs:text-xl text-base font-semibold text-[#b2b2b2]">
          {title}
        </h1>
        <p className="xs:text-xs text-[10px] font-normal ">{text}</p>
      </div>
      {children}
    </div>
  );
};

export default GameCardLayout;
